export const SIGN_MDT_DISEASE = {
  BBHC: 5,
  TTTQM: 6
}
